"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isString;

function isString(value) {
  return typeof value === 'string';
}